import GlobalClasses from 'styles/global'
import React, { useEffect, useRef, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { addToCartGtm, removeFromCartGtm } from 'utils/GtmTracking'

const useStyles = createUseStyles((theme) => {
  return {
    ...GlobalClasses,

    inCartInput: {
      width: '90px',
      height: '31px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

      padding: '6px 5px',
      color: theme.colors.darkGrey,
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px',

      boxShadow:
        'inset 2px 2px 2px rgba(166, 171, 189, 0.5), inset -2px -2px 3px #fafbff',
      borderRadius: '26px',
      border: '1px solid rgba(119, 123, 145, 0.11)',
      backgroundColor: '#fafafa',
      backgroundImage:
        'linear-gradient(-42deg, rgba(0, 0, 0, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%)',

      '& button': {
        background: 'none',
        border: 'none',
        borderRadius: '10px',
        color: theme.colors.darkGrey,
        fontSize: '20px',
        fontWeight: '700',

        '&:hover': {
          textShadow: '1px 2px 5px rgba(0,0,0, .4)',
        },

        '&:focus': {
          outline: 'none',
        },
      },
      '& input': {
        backgroundColor: 'transparent',
        border: 'none',
        color: theme.colors.darkGrey,
        fontSize: '12px',
        fontWeight: '700',
        letterSpacing: '0.5px',
        width: '30px',
        textAlign: 'center',
        '&:focus': {
          outline: 'none',
        },
      },
    },
  }
})

type DataProps = {
  value: number
  handlePlus: () => void
  handleMinus: () => void
  inputChange: (number) => void
  gtmItem?: any
  onBlurCallback?: (value: number) => void
}

const InputNumber: React.ComponentType<DataProps> = ({
  value,
  handlePlus,
  handleMinus,
  inputChange,
  gtmItem,
  onBlurCallback,
}) => {
  const classes = useStyles()
  const [inputValue, setInputValue] = useState<number>(Number(value) || 0)
  const focusValue = useRef<number>(Number(value) || 0)

  useEffect(() => {
    setInputValue(Number(value))
  }, [value])

  const isInt = (n) => {
    return n % 1 === 0
  }

  const onBlur = () => {
    if (typeof inputValue === 'undefined') {
      setInputValue(0)
      inputChange(0)
    } else if (inputValue !== focusValue.current) {
      onBlurCallback?.(inputValue)
    }
  }

  const onFocus = () => {
    focusValue.current = inputValue
  }

  const onChange = (newValue) => {
    if (
      isNaN(newValue.target.value) ||
      !isInt(newValue.target.value) ||
      newValue.target.value.includes('.')
    ) {
      return
    }

    if (newValue.target.value === '') {
      setInputValue(undefined)
      return
    }

    setInputValue(parseInt(newValue.target.value))
    if (newValue.target.value) {
      inputChange(newValue.target.value)
    }
  }

  const onHandleMinus = () => {
    const newValue = inputValue - 1
    setInputValue(newValue)
    handleMinus()

    if (gtmItem) {
      removeFromCartGtm({ ...gtmItem, quantity: 1 })
    }
  }

  const onHandlePlus = () => {
    const newValue = inputValue + 1
    setInputValue(newValue)
    handlePlus()

    if (gtmItem) {
      addToCartGtm({ ...gtmItem, quantity: 1 })
    }
  }

  return (
    <div className={classes.inCartInput}>
      <button onClick={() => onHandleMinus()}>-</button>
      <input
        type="text"
        pattern="[0-9]*"
        value={inputValue}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
      ></input>
      <button onClick={() => onHandlePlus()}>+</button>
    </div>
  )
}

export default InputNumber
